// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
// import './assets/scss/doorstep.scss';
import './assets/css/main.css';
import VueAnalytics from 'vue-analytics';


import axios from "axios"

import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
    id: 'UA-154657553-1',
    router,
    debug: {
        enabled: true,
    }
});

// Tawk.to Script
var Tawk_API = Tawk_API || {},
    Tawk_LoadStart = new Date();
(function() {
    var s1 = document.createElement("script"),
        s0 = document.getElementsByTagName("script")[0];
    s1.async = true;
    s1.src = 'https://embed.tawk.to/60e48e55d6e7610a49a9eb29/1f9ucnvoc';
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');
    s0.parentNode.insertBefore(s1, s0);
})();

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js